import { forwardRef, memo, PropsWithChildren, useImperativeHandle, useRef } from 'react';
import styled from 'styled-components';
import MainMenuContent, { OptionsCardMenuHandle } from './main-menu-content';
import { OptionTitle } from './menu-datas';
import 'bootstrap/dist/css/bootstrap.min.css';

const S = {
  Container: styled.main`
    position: fixed;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    height: 5vh;
    display: flex;
  `,
};

export type MenuScreenHandle = {
  open: () => void;
};

type Props = {
  optionTitle: OptionTitle;
};

const MenuScreen = forwardRef<MenuScreenHandle, PropsWithChildren<Props>>(({ optionTitle = 'Home' }: Props, ref) => {
  const optionsCardMenuHandle = useRef<OptionsCardMenuHandle>(null);

  useImperativeHandle(ref, () => ({
    open: () => {
      optionsCardMenuHandle.current?.open();
    },
  }));

  return (
    <S.Container>
      <MainMenuContent ref={optionsCardMenuHandle} optionTitle={optionTitle} />
    </S.Container>
  );
});

export default memo(MenuScreen);
